import React, { Component } from 'react';

class LimiteCompraSeleccionadoItem extends Component {
    format(valor){
        var num = String(valor).replace(/\./g,'').split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g,'$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/,'');
           return num
   }
    render() {
        const { id, codigo, valor, moneda } = this.props;        
        let tipoMoneda = (moneda == 1 ? '$ ' : 'U$D ')
        let codVal=this.format(valor)
        let codigoValor = (codigo + ' - ' + tipoMoneda  + codVal);
        return (
            this.props.id != 0 &&
            <li className="inlineListItem right-separator-xxs">
                <div className="btn-group top-separator-xxxs">
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable">{codigoValor}</button>
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right" onClick={() => this.props.removeSelectedPurchaseLimit(this.props.id)}>
                        <span key={this.props.key} className="ti-close span-closable color-white" title="Quitar límite."></span>
                    </button>
                </div>
            </li>
        );
    }
};

export default LimiteCompraSeleccionadoItem;